import { Component, ViewEncapsulation } from "@angular/core";
import { SiteConfig } from "src/app/models/site.config.models";
import { BrandingService } from "src/app/services/branding.service";
import { CandidateMeetingModel, InterviewerModel } from "../../interviews.models";
import { BookingType, InterviewStatus } from "../../interviews.enums";
import { InterviewsService } from "../../services/interviews.service";
import { Router } from "@angular/router";
import { RouteReservedPrefix } from "src/app/constants/route-reserved-prefix";

@Component({
    selector: 'interview-list-view',
    templateUrl: './interview-list-view.page.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InterviewListViewPage {
  public branding: SiteConfig|null = null;
  public dashboardInfo$ = this.interviewsService.dashboardInfo$;

  public upcomingMeetings: CandidateMeetingModel[] = [];
  public pastMeetings: CandidateMeetingModel[] = [];

  public InterviewStatus = InterviewStatus;
  public BookingType = BookingType;

  constructor(
    brandingService: BrandingService,
    private interviewsService: InterviewsService,
    private router: Router
  ){
    brandingService.branding$.subscribe(b => this.branding = b);

    interviewsService.meetings$.subscribe(meetings => {
      this.upcomingMeetings = meetings.filter(m => m.isUpcoming);
      this.pastMeetings = meetings.filter(m => !m.isUpcoming);
    });
  }

  public showViewDetailsPage(meeting: CandidateMeetingModel) {
    this.router.navigate([RouteReservedPrefix.INTERVIEWS, 'details', meeting.id], { state: { fromButton: true } });
  }
}
